//import { WEBSOCKET_STATUS } from '../utility/constants';
//Main thread
class DedicatedWorkerClass {
    constructor(onMessageCtxNFunc = null, onErrorCtxNFunc = null) {
        if(!!window.Worker) {
            this.worker = new Worker( new URL("worker.js", import.meta.url) );
//            this.worker = new Worker('worker.js', {
//                type: "classic",
//            });

this.worker.onerror = (e) => this.onError(e)
this.worker.onmessage = (e) => this.onMessage(e)
this.userCallbacks = {
    onMessageCtxNFunc,
    onErrorCtxNFunc
}
//this.worker.postMessage({url: process.env.REACT_APP_WS_ENDPOINT}, []);
        } else {
            throw new Error('WebWorker not supported by browser. Please use an updated browser.')
        }
    }

    postMessage (data = {}, transferData = []) {
        this.worker.postMessage(data, transferData)
    }

    terminate () {
        this.worker.closeWebSocket()
        this.worker.terminate()
        this.worker = null
    }

    onError (e) {
        console.log('There is an error with the dedicated worker thread of Order Table', e)
        this.userCallbacks.onErrorCtxNFunc && 
            this.userCallbacks.onErrorCtxNFunc.func.apply(this.userCallbacks.onErrorCtxNFunc.ctx, [e])
    }

    onMessage (e) {
        console.log('Message from worker thread', e)
        console.debug('ctx', this.userCallbacks.onMessageCtxNFunc.ctx);
        this.userCallbacks.onMessageCtxNFunc && 
            this.userCallbacks.onMessageCtxNFunc.func.apply(this.userCallbacks.onMessageCtxNFunc.ctx, [e.data])
    }
}

export default DedicatedWorkerClass